var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"image_component"},on:{"click":function($event){return _vm.$emit('emitFullScreenImage',_vm.image)}}},[_c('img',{attrs:{"src":_vm.image,"alt":"Repeater Images","id":"component_image"},on:{"error":_vm.replaceByDefault}})])
}
var staticRenderFns = []

export { render, staticRenderFns }